(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  document.querySelectorAll('[data-fuzzy-search]').forEach(async (container) => {
    const query = container.dataset.query?.trim();
    if (!query) return;

    const url = new URL('/search/suggest.json', window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '12');
    url.searchParams.set('resources[options][unavailable_products]', 'hide');

    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const payload = await response.json();
      const products = payload?.resources?.results?.products || [];
      if (products.length === 0) return;

      container.querySelector('h2').textContent = container.dataset.title;
      container.querySelector('p').textContent = container.dataset.copy;
      const list = container.querySelector('ul');
      const currency = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: 'CAD',
      });

      products.forEach((product) => {
        const item = document.createElement('li');
        item.className = 'sh-fuzzy-card';
        const link = document.createElement('a');
        link.href = product.url;
        const image = document.createElement('img');
        image.src = product.image || product.featured_image?.url || '';
        image.alt = product.featured_image?.alt || product.title;
        image.loading = 'lazy';
        const vendor = document.createElement('small');
        vendor.textContent = product.vendor || '';
        const title = document.createElement('h3');
        title.textContent = product.title;
        const price = document.createElement('strong');
        price.textContent = currency.format(Number(product.price || 0));
        const action = document.createElement('span');
        action.textContent = container.dataset.view;
        link.append(image, vendor, title, price, action);
        item.append(link);
        list.append(item);
      });

      container.hidden = false;
      container.parentElement?.querySelector('.sh-search-products')?.setAttribute('hidden', '');
    } catch (error) {
      console.warn('Fuzzy product search fallback unavailable.', error);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-health-age-finder"] && !Shopify.designMode) return;
  try {
    
  class SimplyHealthAgeFinder {
    constructor(root) {
      if (root.dataset.ageFinderInitialized === 'true') return;
      root.dataset.ageFinderInitialized = 'true';
      this.root = root;
      this.options = Array.from(root.querySelectorAll('[data-age-option]'));
      this.clear = root.querySelector('[data-age-clear]');
      this.next = root.querySelector('[data-age-next]');
      document.body.classList.add('sh-age-finder-page');
      this.bind();
      this.restore();
    }

    bind() {
      this.options.forEach((option) => option.addEventListener('click', () => {
        this.options.forEach((item) => {
          const isSelected = item === option;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-pressed', String(isSelected));
        });
        this.update();
      }));
      this.clear?.addEventListener('click', () => {
        this.options.forEach((option) => {
          option.classList.remove('is-selected');
          option.setAttribute('aria-pressed', 'false');
        });
        this.update();
      });
      this.next?.addEventListener('click', () => {
        const selected = this.options.filter((option) => option.classList.contains('is-selected'));
        if (!selected.length) return;
        const params = new URLSearchParams({ view: 'health-needs' });
        params.set('sh_persona', selected[0].dataset.value);
        params.set('sh_personas', selected[0].dataset.value);
        params.set('persona_terms', selected[0].dataset.terms);
        window.location.assign(`${window.Shopify?.routes?.root || '/'}search?${params.toString()}`);
      });
      this.root.querySelector('[data-age-back]')?.addEventListener('click', () => {
        if (window.history.length > 1) window.history.back();
        else window.location.assign(window.Shopify?.routes?.root || '/');
      });
    }

    restore() {
      const selected = new URLSearchParams(window.location.search).get('sh_personas');
      if (selected) {
        const selectedValue = selected.split(',')[0];
        this.options.forEach((option) => {
          const isSelected = option.dataset.value === selectedValue;
          option.classList.toggle('is-selected', isSelected);
          option.setAttribute('aria-pressed', String(isSelected));
        });
      }
      this.update();
    }

    update() {
      const hasSelection = this.options.some((option) => option.classList.contains('is-selected'));
      if (this.clear) this.clear.disabled = !hasSelection;
      if (this.next) this.next.disabled = !hasSelection;
    }
  }

  const initializeSimplyHealthAgeFinder = (scope = document) => {
    if (scope.matches?.('[data-age-finder]')) new SimplyHealthAgeFinder(scope);
    scope.querySelectorAll?.('[data-age-finder]').forEach((root) => new SimplyHealthAgeFinder(root));
  };

  initializeSimplyHealthAgeFinder();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeSimplyHealthAgeFinder(), { once: true });
  }

  window.addEventListener('pageshow', () => initializeSimplyHealthAgeFinder());
  document.addEventListener('shopify:section:load', (event) => initializeSimplyHealthAgeFinder(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-health-ai-guide"] && !Shopify.designMode) return;
  try {
    
  class SimplyHealthAiGuide {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-ai-form]');
      this.steps = Array.from(root.querySelectorAll('[data-ai-step]'));
      this.current = 1;
      this.error = root.querySelector('[data-ai-error]');
      document.body.classList.add('sh-ai-guide-page');
      this.bind();
      this.render();
    }

    bind() {
      this.root.querySelector('[data-ai-next]')?.addEventListener('click', () => {
        if (!this.validateStep()) return;
        this.current = Math.min(5, this.current + 1);
        this.render();
      });
      this.root.querySelector('[data-ai-previous]')?.addEventListener('click', () => {
        this.current = Math.max(1, this.current - 1);
        this.render();
      });
      this.root.querySelector('[data-ai-back]')?.addEventListener('click', () => {
        if (this.current > 1) { this.current -= 1; this.render(); }
        else if (window.history.length > 1) window.history.back();
        else window.location.assign(window.Shopify?.routes?.root || '/');
      });
      this.form?.querySelectorAll('input[name="goal"]').forEach((input) => input.addEventListener('change', () => {
        const checked = this.form.querySelectorAll('input[name="goal"]:checked');
        if (checked.length > 3) input.checked = false;
      }));
      this.form?.querySelectorAll('input[name="safety"]').forEach((input) => input.addEventListener('change', () => this.updateSafety(input)));
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!this.validateStep()) return;
        this.showResults();
      });
    }

    updateSafety(changed) {
      const inputs = Array.from(this.form.querySelectorAll('input[name="safety"]'));
      if (changed.value === 'none' && changed.checked) inputs.filter((item) => item !== changed).forEach((item) => { item.checked = false; });
      if (changed.value !== 'none' && changed.checked) this.form.querySelector('[data-safety-none]').checked = false;
      const needsCare = inputs.some((item) => item.checked && item.value !== 'none');
      this.root.querySelector('[data-ai-safety-notice]').hidden = !needsCare;
    }

    validateStep() {
      let valid = true;
      if (this.current === 1) valid = Boolean(this.form.querySelector('input[name="profile"]:checked'));
      if (this.current === 2) valid = this.form.querySelectorAll('input[name="goal"]:checked').length > 0;
      if (this.current === 3) valid = Boolean(this.form.querySelector('input[name="duration"]:checked')) && Boolean(this.form.querySelector('input[name="priority"]:checked'));
      if (this.current === 4) valid = Boolean(this.form.querySelector('input[name="format"]:checked')) && Boolean(this.form.querySelector('input[name="budget"]:checked'));
      if (this.current === 5) valid = this.form.querySelectorAll('input[name="safety"]:checked').length > 0 && Boolean(this.form.querySelector('input[name="acknowledge"]:checked'));
      this.error.hidden = valid;
      return valid;
    }

    render() {
      this.steps.forEach((step) => {
        const active = Number(step.dataset.aiStep) === this.current;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      this.root.querySelector('[data-ai-progress-bar]').style.width = `${this.current * 20}%`;
      this.root.querySelector('[data-ai-step-label]').textContent = String(this.current);
      this.root.querySelector('[data-ai-previous]').hidden = this.current === 1;
      this.root.querySelector('[data-ai-next]').hidden = this.current === 5;
      this.root.querySelector('[data-ai-submit]').hidden = this.current !== 5;
      this.error.hidden = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    showResults() {
      const checkedTerms = Array.from(this.form.querySelectorAll('[data-terms]:checked')).map((input) => input.dataset.terms).filter(Boolean);
      const goalValues = Array.from(this.form.querySelectorAll('input[name="goal"]:checked')).map((input) => input.value);
      const profile = this.form.querySelector('input[name="profile"]:checked');
      const format = this.form.querySelector('input[name="format"]:checked');
      const budget = this.form.querySelector('input[name="budget"]:checked');
      const params = new URLSearchParams({ type: 'product', view: 'recommendations' });
      params.set('q', checkedTerms.join(' OR '));
      params.set('sh_base_q', checkedTerms.join(' OR '));
      params.set('sh_persona', profile.value);
      params.set('sh_categories', goalValues.join(','));
      params.set('sh_form', format.value);
      params.set('sh_budget', budget.value);
      if (budget.dataset.min) params.set('filter.v.price.gte', budget.dataset.min);
      if (budget.dataset.max) params.set('filter.v.price.lte', budget.dataset.max);
      window.location.assign(`${this.root.dataset.searchUrl}?${params.toString()}`);
    }
  }

  document.querySelectorAll('[data-ai-guide]').forEach((root) => new SimplyHealthAiGuide(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-health-kiosk-exact"] && !Shopify.designMode) return;
  try {
    
  class SimplyHealthDirectHomepage {
    constructor(root) {
      this.homeMenu = root.querySelector('[data-home-menu]');
      document.addEventListener('click', (event) => {
        if (this.homeMenu?.open && !this.homeMenu.contains(event.target)) this.homeMenu.removeAttribute('open');
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.homeMenu?.open) {
          this.homeMenu.removeAttribute('open');
          this.homeMenu.querySelector('summary')?.focus();
        }
      });
      this.promoCarousel = root.querySelector('[data-promo-carousel]');
      this.promoSlide = root.querySelector('[data-promo-slide]');
      this.promoDots = Array.from(root.querySelectorAll('[data-promo-dot]'));
      this.promoIndex = 0;
      root.querySelector('[data-promo-previous]')?.addEventListener('click', () => this.showPromo(this.promoIndex - 1));
      root.querySelector('[data-promo-next]')?.addEventListener('click', () => this.showPromo(this.promoIndex + 1));
      this.promoDots.forEach((dot) => dot.addEventListener('click', () => this.showPromo(Number(dot.dataset.promoDot))));
      this.promoTimer = window.setInterval(() => this.showPromo(this.promoIndex + 1), 7000);
      this.rewardsDialog = root.querySelector('[data-rewards-dialog]');
      root.querySelectorAll('[data-open-rewards]').forEach((button) => button.addEventListener('click', () => this.openRewards()));
      root.querySelector('[data-close-rewards]')?.addEventListener('click', () => this.rewardsDialog?.close());
      this.rewardsDialog?.addEventListener('click', (event) => {
        if (event.target === this.rewardsDialog) this.rewardsDialog.close();
      });
      if (root.querySelector('[data-rewards-success]')) this.openRewards();
      this.productSearchForm = root.querySelector('.sh-direct__search');
      this.productSearchForm?.addEventListener('submit', (event) => this.submitProductSearch(event));
      this.languageSearch = root.querySelector('[data-language-search]');
      this.languageItems = Array.from(root.querySelectorAll('[data-language-item]'));
      this.languageEmpty = root.querySelector('[data-language-empty]');
      this.languageSearch?.addEventListener('input', () => this.filterLanguages());
      root.querySelectorAll('[data-language-option]').forEach((option) => {
        option.addEventListener('click', () => {
          try {
            localStorage.setItem('simply-health-locale-selected', option.dataset.value || '');
          } catch (error) {
            // Language switching must still work when browser storage is unavailable.
          }
        });
      });
      this.finderDialog = root.querySelector('[data-product-finder-dialog]');
      this.finderOptions = Array.from(this.finderDialog?.querySelectorAll('[data-finder-option]') || []);
      this.selectionCount = this.finderDialog?.querySelector('[data-selection-count]');
      this.clearSelection = this.finderDialog?.querySelector('[data-clear-product-finder]');
      this.showMatches = this.finderDialog?.querySelector('[data-show-product-matches]');
      root.querySelector('[data-open-product-finder]')?.addEventListener('click', () => this.openFinder());
      this.finderDialog?.querySelector('[data-close-product-finder]')?.addEventListener('click', () => this.finderDialog?.close());
      this.finderDialog?.addEventListener('click', (event) => {
        if (event.target === this.finderDialog) this.finderDialog.close();
      });
      this.finderOptions.forEach((option) => option.addEventListener('click', () => this.toggleFinderOption(option)));
      this.clearSelection?.addEventListener('click', () => this.clearFinderSelections());
      this.showMatches?.addEventListener('click', () => this.findProducts());
      this.updateFinderSelection();
    }

    showPromo(index) {
      this.promoIndex = (index + 2) % 2;
      if (this.promoSlide) this.promoSlide.hidden = this.promoIndex !== 1;
      this.promoDots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === this.promoIndex));
    }

    openRewards() {
      if (typeof this.rewardsDialog?.showModal === 'function') this.rewardsDialog.showModal();
      else this.rewardsDialog?.setAttribute('open', '');
      this.rewardsDialog?.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
    }

    submitProductSearch(event) {
      event.preventDefault();
      const query = this.productSearchForm?.querySelector('input[name="q"]')?.value.trim();
      if (!query) return;
      const url = new URL(this.productSearchForm.action, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[unavailable_products]', 'hide');
      url.searchParams.set('options[prefix]', 'last');
      window.location.assign(url.toString());
    }

    filterLanguages() {
      const query = this.languageSearch.value.trim().toLocaleLowerCase();
      let visible = 0;
      this.languageItems.forEach((item) => {
        const matches = item.textContent.toLocaleLowerCase().includes(query);
        item.hidden = !matches;
        if (matches) visible += 1;
      });
      if (this.languageEmpty) this.languageEmpty.hidden = visible !== 0;
    }

    openFinder() {
      if (typeof this.finderDialog?.showModal === 'function') this.finderDialog.showModal();
      else this.finderDialog?.setAttribute('open', '');
      this.finderDialog?.querySelector('[data-product-finder-surface]')?.focus({ preventScroll: true });
    }

    toggleFinderOption(option) {
      const selected = option.getAttribute('aria-pressed') !== 'true';
      option.setAttribute('aria-pressed', String(selected));
      option.classList.toggle('is-selected', selected);
      this.updateFinderSelection();
    }

    clearFinderSelections() {
      this.finderOptions.forEach((option) => {
        option.setAttribute('aria-pressed', 'false');
        option.classList.remove('is-selected');
      });
      this.updateFinderSelection();
    }

    selectedFinderOptions() {
      return this.finderOptions.filter((option) => option.getAttribute('aria-pressed') === 'true');
    }

    updateFinderSelection() {
      const count = this.selectedFinderOptions().length;
      const label = this.finderDialog?.dataset.selectedLabel || 'selected';
      if (this.selectionCount) this.selectionCount.textContent = `${count} ${label}`;
      if (this.clearSelection) this.clearSelection.disabled = count === 0;
      if (this.showMatches) this.showMatches.disabled = count === 0;
    }

    findProducts() {
      const selected = this.selectedFinderOptions();
      if (selected.length === 0) return;
      const searchUrl = this.finderDialog?.dataset.searchUrl || '/search';
      const url = new URL(searchUrl, window.location.origin);
      const terms = [...new Set(selected.flatMap((option) => (option.dataset.terms || '').split(/\s+/)).filter(Boolean))];
      const categories = selected.filter((option) => option.dataset.filterKind === 'category').map((option) => option.dataset.value);
      const personas = selected.filter((option) => option.dataset.filterKind === 'persona').map((option) => option.dataset.value);
      url.searchParams.set('q', terms.join(' OR '));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      if (categories.length) url.searchParams.set('sh_categories', categories.join(','));
      if (personas.length) url.searchParams.set('sh_personas', personas.join(','));
      window.location.assign(url.toString());
    }
  }

  document.querySelectorAll('[data-sh-direct]').forEach((root) => new SimplyHealthDirectHomepage(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-health-kiosk-home"] && !Shopify.designMode) return;
  try {
    
  class SimplyHealthKiosk {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-dot]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.timer = null;
      this.autoplay = root.dataset.autoplay === 'true';
      this.interval = Number(root.dataset.interval) || 6000;
      root.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
      root.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
      root.querySelector('[data-kiosk-language]')?.addEventListener('change', (event) => event.currentTarget.form?.submit());
      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      root.addEventListener('focusin', () => this.stop());
      root.addEventListener('focusout', () => this.start());
      this.start();
    }

    show(nextIndex, restart = false) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => slide.classList.toggle('is-active', index === this.index));
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));
      if (restart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  document.querySelectorAll('[data-sh-kiosk]').forEach((root) => new SimplyHealthKiosk(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-health-needs-finder"] && !Shopify.designMode) return;
  try {
    
  class SimplyHealthNeedsFinder {
    constructor(root) {
      this.root = root;
      this.options = Array.from(root.querySelectorAll('[data-need-option]'));
      this.count = root.querySelector('[data-needs-count]');
      this.next = root.querySelector('[data-needs-next]');
      this.params = new URLSearchParams(window.location.search);
      document.body.classList.add('sh-needs-page');
      this.bind();
      this.restore();
    }

    bind() {
      this.options.forEach((option) => option.addEventListener('click', () => {
        const selected = !option.classList.contains('is-selected');
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', String(selected));
        this.update();
      }));
      this.root.querySelectorAll('[data-needs-back]').forEach((button) => button.addEventListener('click', () => {
        if (window.history.length > 1) window.history.back();
        else window.location.assign(`${window.Shopify?.routes?.root || '/'}search?view=product-finder`);
      }));
      this.next?.addEventListener('click', () => {
        const selected = this.selectedOptions();
        if (!selected.length) return;
        const params = new URLSearchParams({ type: 'product', view: 'recommendations' });
        const persona = this.params.get('sh_persona') || '';
        const personaTerms = this.params.get('persona_terms') || '';
        if (persona) params.set('sh_persona', persona);
        params.set('sh_categories', selected.map((option) => option.dataset.value).join(','));
        params.set('q', [personaTerms, selected.map((option) => option.dataset.terms).join(' OR ')].filter(Boolean).join(' OR '));
        window.location.assign(`${window.Shopify?.routes?.root || '/'}search?${params.toString()}`);
      });
    }

    selectedOptions() {
      return this.options.filter((option) => option.classList.contains('is-selected'));
    }

    restore() {
      const saved = (this.params.get('sh_categories') || '').split(',').filter(Boolean);
      const values = new Set(saved);
      this.options.forEach((option) => {
        const selected = values.has(option.dataset.value);
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', String(selected));
      });
      this.update();
    }

    update() {
      const total = this.selectedOptions().length;
      if (this.count) this.count.textContent = String(total);
      if (this.next) this.next.disabled = total === 0;
    }
  }

  document.querySelectorAll('[data-needs-finder]').forEach((root) => new SimplyHealthNeedsFinder(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-health-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('cart-drawer-component')?.setAttribute('auto-open', '');

  document.addEventListener('change', (event) => {
    const variant = event.target.closest('[data-sh-variant-input]');
    if (!variant) return;
    const section = variant.closest('[data-sh-product-section]');
    if (!section) return;
    const variantId = section.querySelector('[data-sh-variant-id]');
    const price = section.querySelector('[data-sh-current-price]');
    const comparePrice = section.querySelector('[data-sh-compare-price]');
    const compareWrap = section.querySelector('[data-sh-compare-wrap]');
    if (variantId) variantId.value = variant.value;
    if (price && variant.dataset.price) price.textContent = variant.dataset.price;
    if (comparePrice) comparePrice.textContent = variant.dataset.comparePrice || '';
    if (compareWrap) compareWrap.hidden = !variant.dataset.comparePrice;
    updateRewardPoints(section);
  });

  const updateRewardPoints = (section) => {
    const variant = section.querySelector('[data-sh-variant-input]:checked');
    const quantity = section.querySelector('input[name="quantity"]');
    const output = section.querySelector('[data-sh-reward-points]');
    if (!output) return;
    const basePoints = Number(variant?.dataset.rewardPoints || output.dataset.basePoints || 0);
    output.dataset.basePoints = String(basePoints);
    output.textContent = String(basePoints * Math.max(1, Number(quantity?.value || 1)));
  };

  document.addEventListener('click', (event) => {
    const section = event.target.closest('[data-sh-product-section]');
    if (!section) return;

    const thumbnail = event.target.closest('[data-sh-thumbnail]');
    if (thumbnail) {
      const image = section.querySelector('.sh-product__hero-image');
      if (image) image.src = thumbnail.dataset.imageSrc;
      section.querySelectorAll('[data-sh-thumbnail]').forEach((button) => button.classList.toggle('is-active', button === thumbnail));
      return;
    }

    const tab = event.target.closest('[data-sh-tab]');
    if (tab) {
      section.querySelectorAll('[data-sh-tab]').forEach((button) => {
        const active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      section.querySelectorAll('[data-sh-panel]').forEach((panel) => {
        const active = panel.dataset.shPanel === tab.dataset.shTab;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      return;
    }

    const membershipDialog = section.querySelector('[data-sh-membership-dialog]');
    if (event.target.closest('[data-sh-membership-open]')) {
      membershipDialog?.showModal();
      return;
    }
    if (event.target.closest('[data-sh-membership-close]')) {
      membershipDialog?.close();
      return;
    }

    const quantity = section.querySelector('input[name="quantity"]');
    if (quantity && event.target.closest('[data-sh-quantity-minus]')) {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      updateRewardPoints(section);
    }
    if (quantity && event.target.closest('[data-sh-quantity-plus]')) {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
      updateRewardPoints(section);
    }
    const checkoutButton = event.target.closest('[data-sh-checkout]');
    if (checkoutButton) {
      const form = checkoutButton.closest('form');
      if (!form) return;
      checkoutButton.disabled = true;
      checkoutButton.setAttribute('aria-busy', 'true');
      const formData = new FormData(form);
      formData.delete('sh_variant');
      fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then((response) => {
          if (!response.ok) throw new Error(section.dataset.addToCartError || '');
          window.location.assign('/checkout');
        })
        .catch((error) => {
          const message = section.querySelector('.sh-product__form-error');
          if (message) {
            message.textContent = error.message || section.dataset.addToCartError || '';
            message.classList.remove('hidden');
          }
          checkoutButton.disabled = false;
          checkoutButton.removeAttribute('aria-busy');
        });
      return;
    }
  });

  document.addEventListener('input', (event) => {
    const quantity = event.target.closest('[data-sh-product-section] input[name="quantity"]');
    if (!quantity) return;
    updateRewardPoints(quantity.closest('[data-sh-product-section]'));
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-sh-membership-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-health-product-finder"] && !Shopify.designMode) return;
  try {
    
  class SimplyHealthProductFinder {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-finder-form]');
      this.query = root.querySelector('[data-finder-query]');
      this.combinedQuery = root.querySelector('[data-finder-combined-query]');
      this.categoryInput = root.querySelector('[data-finder-category-input]');
      this.personaInput = root.querySelector('[data-finder-persona-input]');
      this.category = '';
      this.persona = '';
      this.restoreState();
      this.bindFilters();
      this.bindCategoryDialog();
      this.bindLanguage();
      this.form?.addEventListener('submit', () => this.prepareQuery());
    }

    restoreState() {
      const params = new URLSearchParams(window.location.search);
      this.category = params.get('sh_category') || '';
      this.persona = params.get('sh_persona') || '';
      if (this.query) this.query.value = params.get('display_q') || '';
      this.updateControls();
    }

    bindFilters() {
      this.root.querySelectorAll('[data-category]').forEach((button) => {
        button.addEventListener('click', () => {
          this.category = this.category === button.dataset.category ? '' : button.dataset.category;
          this.submit();
        });
      });
      this.root.querySelectorAll('[data-persona]').forEach((button) => {
        button.addEventListener('click', () => {
          this.persona = this.persona === button.dataset.persona ? '' : button.dataset.persona;
          this.submit();
        });
      });
      this.root.querySelectorAll('[data-clear-finder]').forEach((button) => {
        button.addEventListener('click', () => {
          this.category = '';
          this.persona = '';
          if (this.query) this.query.value = '';
          window.location.assign(`${this.form.action}?type=product`);
        });
      });
    }

    selectedTerms(selector, value) {
      return this.root.querySelector(`${selector}[data-${selector.includes('category') ? 'category' : 'persona'}="${CSS.escape(value)}"]`)?.dataset.terms || '';
    }

    prepareQuery() {
      const terms = [
        this.query?.value.trim() || '',
        this.selectedTerms('[data-category]', this.category),
        this.selectedTerms('[data-persona]', this.persona)
      ].filter(Boolean);
      this.combinedQuery.value = terms.join(' ');
      this.categoryInput.value = this.category;
      this.personaInput.value = this.persona;
    }

    updateControls() {
      this.root.querySelectorAll('[data-category]').forEach((button) => button.classList.toggle('is-active', button.dataset.category === this.category));
      this.root.querySelectorAll('[data-persona]').forEach((button) => button.classList.toggle('is-active', button.dataset.persona === this.persona));
    }

    submit() {
      if (!this.form) return;
      this.updateControls();
      this.prepareQuery();
      this.form.submit();
    }

    bindCategoryDialog() {
      const dialog = this.root.querySelector('[data-category-dialog]');
      const opener = this.root.querySelector('[data-open-category-dialog]');
      opener?.addEventListener('click', () => {
        if (typeof dialog?.showModal === 'function') dialog.showModal();
        else dialog?.setAttribute('open', '');
      });
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }

    bindLanguage() {
      const search = this.root.querySelector('[data-finder-language-search]');
      const items = Array.from(this.root.querySelectorAll('[data-finder-language-item]'));
      const empty = this.root.querySelector('[data-finder-language-empty]');
      search?.addEventListener('input', () => {
        const query = search.value.trim().toLocaleLowerCase();
        let visible = 0;
        items.forEach((item) => {
          const matches = item.textContent.toLocaleLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      });
      this.root.querySelectorAll('[data-finder-language-option]').forEach((option) => {
        option.addEventListener('click', () => {
          const form = option.closest('form');
          const input = form?.querySelector('[data-finder-language-code]');
          if (!form || !input) return;
          input.value = option.dataset.value;
          form.submit();
        });
      });
    }
  }

  document.querySelectorAll('[data-product-finder]').forEach((root) => new SimplyHealthProductFinder(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-health-recommendations"] && !Shopify.designMode) return;
  try {
    
  class SimplyHealthRecommendations {
    constructor(root) {
      this.root = root;
      this.params = new URLSearchParams(window.location.search);
      document.body.classList.add('sh-recommendations-page');
      this.renderChoices();
      this.bind();
    }

    renderChoices() {
      let labels = { personas: {}, needs: {} };
      try {
        labels = JSON.parse(this.root.querySelector('[data-recommendation-labels]')?.textContent || '{}');
      } catch (error) {
        console.warn('Recommendation labels could not be parsed.', error);
      }
      const personaLabels = labels.personas || {};
      const needLabels = labels.needs || {};
      const persona = this.params.get('sh_persona') || '';
      const needs = (this.params.get('sh_categories') || '').split(',').filter(Boolean);
      const personaTarget = this.root.querySelector('[data-persona-label]');
      const needsTarget = this.root.querySelector('[data-needs-labels]');
      if (personaTarget && personaLabels[persona]) personaTarget.textContent = personaLabels[persona].join(' · ');
      if (needsTarget) {
        needsTarget.replaceChildren(...needs.map((value) => {
          const chip = document.createElement('span');
          chip.textContent = needLabels[value] || value.replaceAll('-', ' ');
          return chip;
        }));
      }
      const editParams = new URLSearchParams({ view: 'health-needs' });
      if (persona) editParams.set('sh_persona', persona);
      const personaTerms = this.params.get('persona_terms');
      if (personaTerms) editParams.set('persona_terms', personaTerms);
      if (needs.length) editParams.set('sh_categories', needs.join(','));
      this.root.querySelectorAll('[data-edit-choices]').forEach((link) => { link.href = `${window.Shopify?.routes?.root || '/'}search?${editParams.toString()}`; });
    }

    bind() {
      this.root.querySelector('[data-recommendations-back]')?.addEventListener('click', () => {
        if (window.history.length > 1) window.history.back();
        else window.location.assign(`${window.Shopify?.routes?.root || '/'}search?view=health-needs`);
      });
      this.dialog = this.root.querySelector('[data-refine-dialog]');
      this.form = this.root.querySelector('[data-refine-form]');
      this.root.querySelector('[data-refine-open]')?.addEventListener('click', () => this.openRefine());
      this.root.querySelector('[data-refine-close]')?.addEventListener('click', () => this.closeRefine());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeRefine();
      });
      this.dialog?.addEventListener('close', () => { document.body.style.removeProperty('overflow'); });
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.applyRefinements();
      });
      this.root.querySelector('[data-refine-clear]')?.addEventListener('click', () => this.clearRefinements());
      this.restoreRefinements();
    }

    openRefine() {
      if (!this.dialog) return;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
    }

    closeRefine() {
      if (this.dialog?.open) this.dialog.close();
    }

    restoreRefinements() {
      if (!this.form) return;
      const selections = {
        product_form: this.params.get('sh_form') || 'any',
        budget: this.params.get('sh_budget') || 'any',
        formula: this.params.get('sh_formula') || 'any',
        result_sort: this.params.get('sh_sort') || 'relevance'
      };
      Object.entries(selections).forEach(([name, value]) => {
        const input = this.form.querySelector(`[name="${name}"][value="${value}"]`);
        if (input) input.checked = true;
      });
      const activeCount = Object.entries(selections).filter(([name, value]) => {
        if (name === 'result_sort') return value !== 'relevance';
        return value !== 'any';
      }).length;
      const badge = this.root.querySelector('[data-refine-count]');
      if (badge) {
        badge.textContent = String(activeCount);
        badge.hidden = activeCount === 0;
      }
    }

    applyRefinements() {
      const data = new FormData(this.form);
      const productForm = data.get('product_form') || 'any';
      const budget = data.get('budget') || 'any';
      const formula = data.get('formula') || 'any';
      const resultSort = data.get('result_sort') || 'relevance';
      const baseQuery = this.params.get('sh_base_q') || this.params.get('q') || '';
      const formTerms = {
        capsules: 'capsule OR capsules OR tablet OR tablets OR softgel OR softgels',
        liquid: 'liquid OR drops OR tincture OR oil',
        powder: 'powder',
        chewable: 'gummy OR gummies OR chewable OR chewables'
      };
      const formulaTerms = {
        natural: 'natural OR organic',
        vegan: 'vegan',
        'sugar-free': 'sugar-free OR "sugar free"'
      };
      const groups = [];
      if (baseQuery) groups.push(`(${baseQuery})`);
      if (formTerms[productForm]) groups.push(`(${formTerms[productForm]})`);
      if (formulaTerms[formula]) groups.push(`(${formulaTerms[formula]})`);
      const next = new URLSearchParams(this.params);
      next.set('q', groups.join(' AND '));
      next.set('sh_base_q', baseQuery);
      next.delete('page');
      next.delete('filter.v.price.gte');
      next.delete('filter.v.price.lte');
      next.delete('sort_by');
      [['sh_form', productForm], ['sh_budget', budget], ['sh_formula', formula], ['sh_sort', resultSort]].forEach(([key, value]) => {
        if (value === 'any' || value === 'relevance') next.delete(key);
        else next.set(key, value);
      });
      if (budget === 'under-25') next.set('filter.v.price.lte', '25');
      if (budget === '25-50') {
        next.set('filter.v.price.gte', '25');
        next.set('filter.v.price.lte', '50');
      }
      if (budget === '50-plus') next.set('filter.v.price.gte', '50');
      if (resultSort !== 'relevance') next.set('sort_by', resultSort);
      window.location.assign(`${this.root.dataset.searchUrl}?${next.toString()}`);
    }

    clearRefinements() {
      const next = new URLSearchParams(this.params);
      const baseQuery = next.get('sh_base_q') || next.get('q') || '';
      next.set('q', baseQuery);
      ['sh_base_q', 'sh_form', 'sh_budget', 'sh_formula', 'sh_sort', 'filter.v.price.gte', 'filter.v.price.lte', 'sort_by', 'page'].forEach((key) => next.delete(key));
      window.location.assign(`${this.root.dataset.searchUrl}?${next.toString()}`);
    }
  }

  document.querySelectorAll('[data-recommendations]').forEach((root) => new SimplyHealthRecommendations(root));

  } catch(e) { console.error(e); }
})();
})();
